import WalkthroughContent from "./WalkthroughContent";
import WalkthroughControl from "./WalkthroughControl";


export const contentPlayerPageWalkthrough = [
    
    {
        selector: '.reactour-videoplayer',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Let's Learn How To Use The Platform! This Section Plays Your Content"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        skip
                        onClickNext={() => goTo(step)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'top',
    },
    {
        selector: '.reactour-tilebar',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Use These Options To To Like, Comment and Report About Video"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'center',
    },
    {
        selector: '.reactour-video-duration',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"You Can See The Video Duration Here And Expand This To View Your Suggested Timestamp For The Video"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'center',
    },
    {
        selector: '.reactour-desktop-keypoints',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Here You Can See Keypoints Of Your Video Content And Also Download It"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'right',
    },
    {
        selector: '.reactour-desktop-chatsection',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Here You Can Ask Your Doubts With Video Creator."} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'right',
    },
    {
        selector: '.reactour-desktop-quizsection',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Don't Forget To Submit The Quiz. Course Will Be Marked Complete Only Once All Quizzes Are Completed."} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'right',
    },
    {
        selector: '.reactour-desktop-usergoal',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Enter Your Goal Once & All Quizzes Will Be Generated Based On This Goal"} imagePosition={"center"} />
                    <WalkthroughControl
                        prev
                        end
                        onClickPrev={() => goTo(step - 2)}
                        onClickEnd={() => close()} />
                </div>
            )
        },
        position: 'right',
    },
    
]

export const contentPlayerPageWalkthroughMobile = [
    {
        selector: '.reactour-videoplayer',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Let's Learn How To Use The Platform! This Section Plays Your Content"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        skip
                        onClickNext={() => goTo(step)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'center',
    },
    {
        selector: '.reactour-tilebar',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Use These Options To Like, Comment and Report About Video"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'top',
    },
    {
        selector: '.reactour-video-duration',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"You Can See The Video Duration Here And Expand This To View Your Suggested Timestamp For The Video"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'top',
    },
    {
        selector: '.reactour-keypoints',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Here You Can See Keypoints Of Your Video Content And Also Download It"} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'top',
    },
    {
        selector: '.reactour-chatsection',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Here You Can Ask Your Doubts With Video Creator."} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'top'
    },
    {
        selector: '.reactour-quizsection',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Don't Forget To Submit The Quiz. Course Will Be Marked Complete Only Once All Quizzes Are Completed."} imagePosition={"center"} />
                    <WalkthroughControl
                        next
                        prev
                        skip
                        onClickNext={() => goTo(step)}
                        onClickPrev={() => goTo(step - 2)}
                        onClickSkip={() => close()} />
                </div>
            )
        },
        position: 'top'
    },
    {
        selector: '.reactour-desktop-usergoal',
        content: ({ goTo, step, close }) => {
            return (
                <div style={{ height: '100%' }}>
                    <WalkthroughContent text={"Enter Your Goal Once & All Quizzes Will Be Generated Based On This Goal"} imagePosition={"center"} />
                    <WalkthroughControl
                        end
                        prev
                        onClickPrev={() => goTo(step - 2)}
                        onClickEnd={() => close()} />
                </div>
            )
        },
        position: 'top'
    },
]

